// import React, { useState } from 'react';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import './newproject.scss';
// import withAuth from '../../auth/WithAuth';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';

// const NewProject = () => {
//   const navigate = useNavigate();

//   const [projectData, setProjectData] = useState({
//     title: '',
//     description: '',
//     budget: '',
//     location: '',
//     deadline: '',
//   });

//   const [images, setImages] = useState([]); // actual File objects
//   const [previewUrls, setPreviewUrls] = useState([]); // for image preview
//   const [loading, setLoading] = useState(false);

//   // Handle text input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProjectData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Handle image uploads
//   const handleImageUpload = (e) => {
//     const files = Array.from(e.target.files);
//     const newPreviews = files.map((file) => URL.createObjectURL(file));

//     setImages((prev) => [...prev, ...files]);
//     setPreviewUrls((prev) => [...prev, ...newPreviews]);
//   };

//   // Remove a selected image
//   const handleRemoveImage = (index) => {
//     setImages((prev) => prev.filter((_, i) => i !== index));
//     setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append('title', projectData.title);
//       formData.append('description', projectData.description);
//       formData.append('budget', projectData.budget);
//       formData.append('location', projectData.location);
//       formData.append('deadline', projectData.deadline);

//       images.forEach((file) => formData.append('uploaded_images', file));

//       await serverUrlAuth.post('projects/create-project/', formData);

//       toast.success('🎉 Project created successfully and artisans assigned!');
//       navigate('/projects');
//     } catch (error) {
//       console.error('Upload error:', error);
//       toast.error('❌ Failed to create project. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="new-project-page">
//         {/* HERO SECTION */}
//         <section className="project-hero">
//           <div className="overlay">
//             <div className="hero-content">
//               <h1>Bring Your Vision to Life 🎨</h1>
//               <p>
//                 Describe your dream piece, set your budget, and connect with
//                 artisans who’ll make it real.
//               </p>
//             </div>
//           </div>
//         </section>

//         {/* MAIN FORM SECTION */}
//         <div className="project-workspace container">
//           {/* Left: Form */}
//           <form className="project-form" onSubmit={handleSubmit}>
//             <h2>🪚 Project Details</h2>

//             <div className="form-group">
//               <label>Project Title</label>
//               <input
//                 type="text"
//                 name="title"
//                 placeholder="e.g. Custom Oak Dining Table"
//                 value={projectData.title}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>
//                 Description{' '}
//                 <span className="description-span">
//                   (Give the dimensions,material, material colour, colour code if
//                   possible e.t.c. be as specific as possible)
//                 </span>
//               </label>

//               <textarea
//                 name="description"
//                 placeholder="Describe your project idea, preferred materials, dimensions, etc."
//                 value={projectData.description}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Estimated Budget (KSh)</label>
//               <input
//                 type="number"
//                 name="budget"
//                 placeholder="e.g. 25,000"
//                 value={projectData.budget}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Location</label>
//               <input
//                 type="text"
//                 name="location"
//                 placeholder="e.g. Nairobi, Kenya"
//                 value={projectData.location}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group deadline-field premium">
//               <label className="form-label">Preferred Deadline</label>

//               <div>
//                 <div className="date-input-wrapper">
//                   <input
//                     type="date"
//                     min={new Date().toISOString().split('T')[0]}
//                     name="deadline"
//                     value={projectData.deadline}
//                     onChange={handleChange}
//                     className="date-input"
//                     required
//                   />
//                 </div>
//               </div>

//               {projectData.deadline && (
//                 <div className="deadline-preview">
//                   <div className="preview-header">
//                     <span className="preview-icon">📅</span>
//                     <span className="preview-title">
//                       Selected Proposed Completion Date
//                     </span>
//                   </div>
//                   <div className="selected-date">
//                     {new Date(projectData.deadline).toLocaleDateString(
//                       'en-US',
//                       {
//                         weekday: 'long',
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric',
//                       },
//                     )}
//                   </div>
//                   <p className="days-from-now">
//                     {(() => {
//                       const today = new Date();
//                       const selectedDate = new Date(projectData.deadline);
//                       // Reset times to avoid partial day issues
//                       today.setHours(0, 0, 0, 0);
//                       selectedDate.setHours(0, 0, 0, 0);
//                       const diffTime = selectedDate - today;
//                       const diffDays = Math.round(
//                         diffTime / (1000 * 60 * 60 * 24),
//                       );
//                       return `This is ${diffDays} day${
//                         diffDays !== 1 ? 's' : ''
//                       } from now.`;
//                     })()}
//                   </p>
//                 </div>
//               )}
//             </div>

//             <div className="form-group">
//               <label>Reference Images</label>
//               <input
//                 type="file"
//                 multiple
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//             </div>

//             <button type="submit" className="submit-btn" disabled={loading}>
//               {loading ? 'Uploading...' : '🚀 Post Project'}
//             </button>
//           </form>

//           {/* Right: Preview Board */}
//           <div className="preview-board">
//             <h2>📸 Inspiration Board</h2>
//             <p>
//               Upload photos or sketches of your desired style, and we’ll match
//               you with artisans who can bring it to life.
//             </p>

//             <div className="image-grid">
//               {previewUrls.length > 0 ? (
//                 previewUrls.map((url, index) => (
//                   <div key={index} className="image-card">
//                     <img src={url} alt="Preview" />
//                     <button
//                       type="button"
//                       className="remove-btn"
//                       onClick={() => handleRemoveImage(index)}
//                     >
//                       ✖
//                     </button>
//                   </div>
//                 ))
//               ) : (
//                 <div className="placeholder">
//                   <span>🖼 No images uploaded yet</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default withAuth(NewProject, 'client');
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FurnitureNavbar from '../../../components/layout/Nav';
import './newproject.scss';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaRocket,
  FaImage,
  FaTrash,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaFileAlt,
  FaChevronRight,
} from 'react-icons/fa';

const NewProject = () => {
  const navigate = useNavigate();

  const [projectData, setProjectData] = useState({
    title: '',
    description: '',
    budget: '',
    location: '',
    deadline: '',
  });

  const [images, setImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newPreviews = files.map((file) => URL.createObjectURL(file));

    setImages((prev) => [...prev, ...files]);
    setPreviewUrls((prev) => [...prev, ...newPreviews]);
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('title', projectData.title);
      formData.append('description', projectData.description);
      formData.append('budget', projectData.budget);
      formData.append('location', projectData.location);
      formData.append('deadline', projectData.deadline);

      images.forEach((file) => formData.append('uploaded_images', file));

      await serverUrlAuth.post('projects/create-project/', formData);

      toast.success('🎉 Project created successfully! Artisans will be notified.');
      navigate('/my-requests');
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('❌ Failed to create project. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getDaysFromNow = () => {
    if (!projectData.deadline) return null;
    const today = new Date();
    const selectedDate = new Date(projectData.deadline);
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    const diffTime = selectedDate - today;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getUrgencyLevel = () => {
    const days = getDaysFromNow();
    if (days === null) return null;
    if (days <= 7) return 'urgent';
    if (days <= 30) return 'moderate';
    return 'flexible';
  };

  const getUrgencyText = () => {
    const level = getUrgencyLevel();
    if (level === 'urgent') return '⚠️ Urgent - Short timeline';
    if (level === 'moderate') return '📅 Moderate - Comfortable timeline';
    return '🌿 Flexible - Ample time for crafting';
  };

  return (
    <div className="modern-dashboard">
      <FurnitureNavbar />

      {/* Hero Section */}
      <section className="hero-craftsmanship">
        <div className="hero-pattern"></div>
        <div className="hero-content-modern">
          <div className="welcome-badge">
            <span className="badge-icon">✨</span>
            <span>Start a New Project</span>
          </div>
          <h1 className="hero-title">
            <span className="gradient-text">Bring Your Vision</span>
            <span className="hero-accent">To Life</span>
          </h1>
          <p className="hero-subtitle">
            Describe your dream piece, set your budget, and connect with skilled artisans
            who'll make it real. Share as many details as possible for the best matches.
          </p>
        </div>
      </section>

      {/* Main Form Section */}
      <div className="new-project-workspace">
        <div className="workspace-container">
          {/* Left: Form */}
          <form className="project-form-modern" onSubmit={handleSubmit}>
            <div className="form-header">
              <h2>
                <FaFileAlt /> Project Details
              </h2>
              <p>Fill in the information below to get started</p>
            </div>

            <div className="form-group-modern">
              <label>Project Title</label>
              <input
                type="text"
                name="title"
                placeholder="e.g., Custom Oak Dining Table"
                value={projectData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-modern">
              <label>
                Description
                <span className="label-hint">
                  (Dimensions, materials, color, finish - be as specific as possible)
                </span>
              </label>
              <textarea
                name="description"
                placeholder="Describe your project idea, preferred materials, dimensions, style preferences, etc."
                value={projectData.description}
                onChange={handleChange}
                required
                rows="5"
              />
            </div>

            <div className="form-row-modern">
              <div className="form-group-modern">
                <label>
                  <FaMoneyBillWave /> Estimated Budget (KSh)
                </label>
                <input
                  type="number"
                  name="budget"
                  placeholder="e.g., 25000"
                  value={projectData.budget}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-modern">
                <label>
                  <FaMapMarkerAlt /> Location
                </label>
                <input
                  type="text"
                  name="location"
                  placeholder="e.g., Nairobi, Kenya"
                  value={projectData.location}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group-modern deadline-field">
              <label>
                <FaCalendarAlt /> Preferred Deadline
              </label>
              <input
                type="date"
                min={new Date().toISOString().split('T')[0]}
                name="deadline"
                value={projectData.deadline}
                onChange={handleChange}
                className="date-input"
                required
              />

              {projectData.deadline && (
                <div className="deadline-preview-modern">
                  <div className={`urgency-badge ${getUrgencyLevel()}`}>
                    {getUrgencyText()}
                  </div>
                  <div className="selected-date">
                    📅 {new Date(projectData.deadline).toLocaleDateString('en-US', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </div>
                  <div className="days-info">
                    {getDaysFromNow() === 0 ? 'Today!' : 
                     getDaysFromNow() === 1 ? 'Tomorrow' :
                     `${getDaysFromNow()} days from now`}
                  </div>
                </div>
              )}
            </div>

            <div className="form-group-modern images-group">
              <label>
                <FaImage /> Reference Images
              </label>
              <div className="file-upload-area-modern">
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageUpload}
                  id="image-upload"
                  className="file-input"
                />
                <label htmlFor="image-upload" className="upload-label">
                  <FaImage />
                  <span>Click or drag to upload images</span>
                  <small>PNG, JPG, WEBP up to 10MB</small>
                </label>
              </div>

              {previewUrls.length > 0 && (
                <div className="image-preview-grid">
                  {previewUrls.map((url, index) => (
                    <div key={index} className="image-preview-card">
                      <img src={url} alt={`Preview ${index + 1}`} />
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={() => handleRemoveImage(index)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button type="submit" className="submit-btn-modern" disabled={loading}>
              {loading ? (
                <>
                  <div className="spinner-small"></div>
                  Creating Project...
                </>
              ) : (
                <>
                  <FaRocket /> Post Project
                </>
              )}
            </button>
          </form>

          {/* Right: Preview Board */}
          <div className="preview-board-modern">
            <div className="preview-header-modern">
              <h2>📸 Inspiration Board</h2>
              <p>Upload photos or sketches of your desired style</p>
            </div>

            <div className="inspiration-content">
              {previewUrls.length > 0 ? (
                <div className="inspiration-grid">
                  {previewUrls.map((url, index) => (
                    <div key={index} className="inspiration-card">
                      <img src={url} alt={`Inspiration ${index + 1}`} />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-inspiration">
                  <div className="empty-icon">🖼️</div>
                  <h4>No images yet</h4>
                  <p>Upload reference images to help artisans understand your vision</p>
                </div>
              )}
            </div>

            <div className="tips-section">
              <h4>💡 Pro Tips</h4>
              <ul>
                <li>Include dimensions for better estimates</li>
                <li>Share color references or hex codes</li>
                <li>Mention preferred wood types or materials</li>
                <li>Add inspiration images for style guidance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuth(NewProject, 'client');